import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=0fdb2bc2&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=0fdb2bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb2bc2",
  null
  
)

export default component.exports